<template>
  <div class="permission-group">
    <div class="permission-group__header">
      <span>Model permissions</span>
    </div>
    <ul class="permission-group__abilities">
      <li
        v-for="normalized in normalizedPermissions"
        :key="normalized.id"
        class="permission-group__abilities__ability"
        @click="goToModel(normalized.modelId)"
      >
        <ToolTip
          :content="normalized.info"
          :delay="[500, 0]"
        >
          {{ normalized.name }}
        </ToolTip>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
/**
 * Used to render a list of model specific permissions.
 *
 * For now, just renders "Run inference on {modelId}".
 */
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import type { ApiKeyPermission } from './types'
import { ABILITY_INFO } from './data'
import ToolTip from '@/uiKit/ToolTip/ToolTip.vue'

const props = defineProps<{ permissions: ApiKeyPermission[] }>()

const router = useRouter()

const normalizedPermissions = computed(() =>
  props.permissions.map((permission) => ({
    id: permission.join(':'),
    name: `${ABILITY_INFO[permission[0]].name} on model ${permission[1].split(':')[1]}`,
    info: ABILITY_INFO[permission[0]].info,
    modelId: permission[1].split(':')[1],
  })),
)

/**
 * Closes settings pane and navigates to model.
 *
 * We cannot use router-link for this, since the settings dialog would remain open in that case.
 * If the settings dialog ever route-navigable, we can replace this with a simple router link.
 */
const goToModel = (modelId: string): void => {
  router.push(`/models/${modelId}`)
}
</script>

<style lang="scss" scoped>
.permission-group {
  &__header {
    color: var(--color-text-subtle);
    @include typographyRegularBody200;
  }

  &__abilities {
    color: var(--color-text-subtlest);
    @include typographyRegularBody200;

    padding-left: 16px;
    margin: 0;

    &__ability {
      cursor: pointer;
    }
  }
}
</style>
